import ko from '@tko/build.knockout';
import _ from 'lodash';
import BaseDialog from '../../../../../components/modal-dialog/base-dialog';
import DialogVM from './top-list-options.vm';
import templateMarkup from 'raw-loader!./top-list-options.template.html';
    

    var instance = null;

    function TopListOptionsModal() {
        if (instance !== null) {
            throw new Error('Cannot instantiate more than one TopListOptionsModal. Call TopListOptionsModal.getInstance() instead!');
        }
    }

    TopListOptionsModal.prototype = {
        dialog: function(config) {
            return BaseDialog.showModal({
                viewModel: new DialogVM(config),
                template: templateMarkup,
                context: this
            });
        },
    };

    TopListOptionsModal.getInstance = function() {
        if (instance === null) {
            instance = new TopListOptionsModal();
        }
        return instance;
    };

    export default TopListOptionsModal.getInstance();

